import {
    addOWAConnectedAccount,
    initializeOwaAccountsStore,
    setAccountStoreInitialized,
} from '../actions';
import {
    ConnectedAccountResponse,
    lazyGetAllConnectedAccounts,
    OAuthProviderType,
} from 'owa-link-account';
import { orchestrator } from 'satcheljs';
import addSeconds from 'owa-datetime/lib/owaDate/addSeconds';
import { now } from 'owa-datetime';
import { assertNever } from 'owa-assert';

/**
 * This orchestrator is triggered from calendar module initializeState.
 * It looks up the existing connected accounts in the server.
 */
orchestrator(initializeOwaAccountsStore, async () => {
    const response = await lazyGetAllConnectedAccounts.importAndExecute();

    const connectedAccounts = response as ConnectedAccountResponse[];
    if (connectedAccounts) {
        connectedAccounts.filter(isSupportedConnectedAccount).forEach(account =>
            addOWAConnectedAccount({
                primarySmtpAddress: account.userAccount.emailAddress,
                displayEmail: account.userAccount.emailAddress,
                accountId: account.userAccount.id,
                anchorMailbox: account.userAccount.routingHint,
                token: account.token.accessToken,
                tokenExpiry: addSeconds(now(), parseInt(account.token.expiresIn)),
                accountProviderType: 'Outlook',
            })
        );
    }

    setAccountStoreInitialized(true);
});

function isSupportedConnectedAccount(connectedAccount: ConnectedAccountResponse): boolean {
    switch (connectedAccount.providerType) {
        case OAuthProviderType.Msa:
        case OAuthProviderType.MsaInt:
            return true;
        case OAuthProviderType.TeamSnap:
            return false;
        default:
            return assertNever(connectedAccount.providerType);
    }
}
